<template>
  <validation-observer ref="ImportantNumberForm" class="form">
    <form ref="form" class="form">
      <b-form-group>
        <validation-provider
          :name="$t('general.address')"
          :rules="{ required: true }"
          v-slot="validationContext"
        >
          <b-row>
            <b-col sm="4">
              <label for="address">
                {{ $t('general.address') }}
              </label>
            </b-col>
            <b-col sm="8">
              <b-form-input
                id="address"
                v-model="address"
                :placeholder="
                  $t('general.address')
                "
                :state="getValidationState(validationContext)"
                aria-describedby="live-feedback"
              />
              <b-form-invalid-feedback id="live-feedback">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </validation-provider>

        <validation-provider
          :name="$t('general.country')"
          :rules="{ required: true }"
          v-slot="validationContext"
        >
          <b-row>
            <b-col sm="4">
              <label for="type">{{ $t('general.country') }}</label>
            </b-col>
            <b-col sm="8">
              <Multiselect
                v-model="country"
                :show-labels="false"
                :options="countries"
                label="name"
                track-by="country_id"
                @input="selectedCountry"
                :state="getValidationState(validationContext)"
                aria-describedby="live-feedback"
                :placeholder="$t('general.select')"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.name }}</strong>
                </template>
              </Multiselect>
              <b-form-invalid-feedback id="live-feedback">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </validation-provider>

        <validation-provider
          :name="$t('general.city')"
          :rules="{ required: true }"
          v-slot="validationContext"
        >
          <b-row>
            <b-col sm="4">
              <label for="type">{{ $t('general.city') }}</label>
            </b-col>
            <b-col sm="8">
              <Multiselect
                v-model="city"
                :show-labels="false"
                :options="citiesList"
                label="name"
                track-by="city_id"
                @input="selectedCity"
                :state="getValidationState(validationContext)"
                aria-describedby="live-feedback"
                :placeholder="$t('general.select')"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.name }}</strong>
                </template>
              </Multiselect>
              <b-form-invalid-feedback id="live-feedback">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </validation-provider>

        <validation-provider
          :name="$t('general.district')"
          :rules="{ required: true }"
          v-slot="validationContext"
        >
          <b-row>
            <b-col sm="4">
              <label for="type">{{ $t('general.district') }}</label>
            </b-col>
            <b-col sm="8">
              <Multiselect
                v-model="town"
                :show-labels="false"
                :options="townsList"
                label="name"
                track-by="town_id"
                @input="selectedTown"
                :state="getValidationState(validationContext)"
                aria-describedby="live-feedback"
                :placeholder="$t('general.select')"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.name }}</strong>
                </template>
              </Multiselect>
              <b-form-invalid-feedback id="live-feedback">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </validation-provider>

        <validation-provider
          :name="$t('defination.importantNumber.form.description')"
          :rules="{ required: true }"
          v-slot="validationContext"
        >
          <b-row>
            <b-col sm="4">
              <label for="description">
                {{ $t('defination.importantNumber.form.description') }}
              </label>
            </b-col>
            <b-col sm="8">
              <b-form-input
                id="description"
                v-model="description"
                :placeholder="
                  $t('defination.importantNumber.formPlaceholder.description')
                "
                :state="getValidationState(validationContext)"
                aria-describedby="live-feedback"
              />
              <b-form-invalid-feedback id="live-feedback">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </validation-provider>

        <validation-provider
          :name="$t('defination.importantNumber.form.important_number')"
          :rules="{
            required:true,
            regex: /^(\+\s\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
          }"
          v-slot="validationContext"
        >
          <b-row>
            <b-col sm="4">
              <label for="number">
                {{ $t('defination.importantNumber.form.important_number') }}
              </label>
            </b-col>
            <b-col sm="8">
              <MaskedInput
                class="form-control"
                id="number"
                v-model="number"
                mask="\+\ 11 (111) 111 1111"
                type="tel"
                :placeholder="
                  $t(
                    'defination.importantNumber.formPlaceholder.important_number',
                  )
                "
                aria-describedby="live-feedback"
                :state="getValidationState(validationContext)"
                @input="important_number_val = arguments[1]"
              />
              <b-form-invalid-feedback id="live-feedback">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-col>
          </b-row>

        </validation-provider>
      </b-form-group>
    </form>
  </validation-observer>
</template>

<script>
import Multiselect from 'vue-multiselect'
import MaskedInput from 'vue-masked-input'

export default {
  name: 'ImportantNumberForm',
  data: function () {
    return {
      address: this.data ? this.data.address : '',
      description: this.data ? this.data.description : '',
      number: this.data ? this.data.number : '90',
      
      country: this.data ? this.data.country : null,
      city: this.data ? this.data.city : null,
      town: this.data ? this.data.town : null,

      country_id: this.data ? this.data.country.id : null,
      city_id: this.data ? this.data.city.id : null,
      town_id: this.data ? this.data.town.id : null,

      townsList:[],
      citiesList:[],
      errMsg: '',
    }
  },
  async created() {
    await this.$store.dispatch('country_list')
    if (this.data) {
      this.country = await this.countries.find(
        (country) => country.country_id === this.country.id,
      )
      await this.$store.dispatch('listCities',this.data.country.id)
      this.citiesList = this.cities
      this.city = await this.cities.find((city) => city.city_id === this.data.city.id)

      await this.$store.dispatch('listTowns', {
        city: this.data.city.id,
        country: this.data.country.id,
      })
      this.townsList = this.towns
      this.town = this.towns.find((town) => town.town_id === this.data.town.id)
    }
  },
  props: {
    data: Object,
    changeData: Function,
    save: Boolean,
    saveState: Function,
    modalName: String,
    modalEvent: Function,
  },
  components: {
    Multiselect,
    MaskedInput,
  },
  computed: {
    countries() {
      return this.$store.getters.getCountries
    },
    cities() {
      return this.$store.getters.getCities
    },
    towns() {
      return this.$store.getters.getTowns
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    clearForm() {
      this.errMsg = ''
      this.description = '',
      this.number = '',
      this.country = {},
      this.city = {},
      this.town = {},

      this.modalEvent(false)
    },
    async selectedCountry(val) {
      this.city = null
      this.town = null
      if (val) {
        await this.$store.dispatch('listCities', val.country_id)
        this.citiesList = this.cities
        this.country = await this.countries.find(
          (country) => country.country_id === val.country_id,
        )
        this.townsList = []
      } else {
        this.citiesList = []
        this.townsList = []
      }
    },
    async selectedCity(val) {
      this.town = null
      if (val) {
        await this.$store.dispatch('listTowns', {
          city: this.city.city_id,
          country: this.country.country_id,
        })
        this.townsList = this.towns
        this.city = await this.cities.find((city) => city.city_id === val.city_id)
      } else {
        this.townsList = []
      } 
    },
    selectedTown(val) {
      if (val) {
        this.town = this.towns.find((town) => town.town_id === val.town_id)
      } else {
        this.town = null
      }
    },
  },
  watch: {
    save: async function (data) {
      if (data) {
        this.$refs.ImportantNumberForm.validate().then(async (success) => {
          if (success) {
            let val = {
              description: this.description,
              address: this.address,
              number: this.number.replaceAll(" ","").replace("(","").replace(")",""),
              country_id: this.country.country_id,
              city_id: this.city.city_id,
              town_id: this.town.town_id,
            }
            switch (this.modalName) {
              case 'add':
                await this.$store.dispatch("addImportantNumbers", val);
                break
              case 'edit':
                val.id = this.data.id
                await this.$store.dispatch("editImportantNumbers", val);
                break
            }
            if (this.$store.getters.getAddressStatus.status == 'Success') {
              this.$store.dispatch('listImportantNumbers')
              this.clearForm()
            } else {
              this.errMsg = i18n.t('general.addErrMsg')
            }
          }
        })
        this.saveState(false)
      }
    },
  },
}
</script>

<style lang="css" scoped>
@import '../styles/modalForm.min.css';
@import '../styles/modal.min.css';
</style>



// WEBPACK FOOTER //
// src/pages/General/Defination/modals/ImportantNumberForm.vue